<template>
  <div class="c-select_wrap">
    <select
      v-model="selectedTrackId"
      class="form-control c-select"
      style="width: 300px">
      <option
        v-for="(track, index) in availableTracks"
        :key="index"
        :value="track.id">
        {{ track.title }}
      </option>
    </select>
  </div>
</template>

<script>

export default {
  name: 'TrackSelector',
  components: {
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    productId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      tracks: [],
      menuShown: false,
      selectedTrackId: null,
    }
  },
  computed: {
    availableTracks() {
      return (this.tracks && this.tracks.length === 1)
        ? this.tracks
        : [{ id: null, title: 'すべて' }, ...this.tracks]
    },
  },
  watch: {
    productId: {
      handler(productId) {
        this.selectedTrackId = null
        if (productId === null) {
          this.tracks = []
          return
        }
        this.fetchItems()
      },
    },
    selectedTrackId: {
      handler(selectedTrackId) {
        this.$emit('input', selectedTrackId)
      },
      immediate: false,
    },
  },
  methods: {
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/reports/all-tracks', {
        params: {
          product_id: this.productId,
        },
      })
      this.tracks = data
      if (this.tracks.length === 1) {
        this.selectedTrackId = this.tracks[0].id
      }
    },
  },
}
</script>
